function extractImportUrl(error: Error): URL | undefined {
  const { message } = error;
  const urlRegex = /(https?:\/\/[^\s'"]+)/;
  const match = message.match(urlRegex);

  if(!match) return undefined;

  return new URL(match[1]);
}

export default extractImportUrl;
